module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/array/from.js
// module id = ./node_modules/@babel/runtime/core-js/array/from.js
// module chunks = 0